export const BuildingContributor = "building_contributor";
export const ResourceContributor = "resource_contributor";
export const UserManager = "user_manager";
export const PlannerAdmin = "planner_admin";
export const PlannerContributor = "planner_contributor";